import { h } from 'preact'
import {
  connectSearchBox
} from 'react-instantsearch/connectors'
import InputGroupWithIcons from '../ui-components/InputGroupWithIcons'
import Icon from '../assets'
import { t } from '../../libs/translationsUtils/translations'

let timeout: undefined | number

const doSearch = (value: string, searchFunc: Function, resetPagination: () => void) => {
  clearTimeout(timeout)

  timeout = window.setTimeout(() => {
    resetPagination()
    searchFunc(value)
  }, 500)
}

const SearchBox = ({ refine, resetPagination, defaultCdn, enableLoader }: { refine: Function, enableLoader: boolean, defaultCdn: string, resetPagination: () => void }) => (
  <div>
    <InputGroupWithIcons
      attributes={{
        type: 'search',
        placeholder: t('Forum', 'live.search.placeholder')
      }}
      className=''
      preIcon={<Icon width={24} height={24} color='#6B707E' icon='search' customClass={enableLoader ? 'opacity' : ''} />}
      onChange={(newValue: string) => doSearch(newValue, refine, resetPagination)}
    />
    {
      enableLoader ? (
        <span className='instant-search-loader small-loader'>
          <img
            src={`${defaultCdn}/images/spinner.gif`}
            alt='loading...' />
        </span>
      ) : null
    }
  </div>
)

const InstantSearchBox = connectSearchBox(SearchBox)

export default InstantSearchBox
